<section class="content-layout right-sidebar-fullheight-basic-inner-scroll">
  <mat-drawer-container>
    <mat-drawer #matDrawer [mode]="'side'" [opened]="false" [position]="'end'" [disableClose]="true">
      <router-outlet></router-outlet>
    </mat-drawer>
    <mat-drawer-content>
      <section class="content">
        <!-- Header -->
        <ts-page-header>
          <ng-container page-header-title>
            <section class="flex flex-col items-start">
              <h5 class="m-0 leading-none" data-cy="properties-saved-view-title">
                {{ savedView.name || 'Aggregated Tasks' }}
              </h5>
              <p class="h-5">
                <ng-container *ngIf="tasksCount.incomplete === 0 && !isLoading">
                  <span>A list of tasks across all related objects</span>
                </ng-container>
                <ng-container *ngIf="tasksCount.incomplete !== 0 && !isLoading">
                  <span>{{ tasksCount }} tasks</span>
                </ng-container>
              </p>
            </section>
          </ng-container>
          <ng-container page-header-action-buttons>
            <section class="flex flex-row gap-2">
              <ts-button
                variant="secondary"
                icon="ts_file-save"
                (click)="openTaskExportDialog()"
                [appAuthorize]="NewPermission.AGGREGATED_TASKS_SHARING_RECORDS"
                denyAction="disable"
              >
                Export</ts-button
              >
            </section>
          </ng-container>
          <ng-container page-header-action-bar>
            <section class="flex items-center relative" [ngClass]="{ loading: isLoading }">
              <!-- Group Panel Button -->
              <ts-button
                [debounceTime]="0"
                type="stroked"
                color="accent"
                [matTooltip]="groupBy ? 'Grouped by: ' + getGroupByLabel() : 'Group tasks'"
                class=""
                (click)="openGroupPanel()"
                [appAuthorize]="NewPermission.AGGREGATED_TASK_LISTS_CREATE"
              >
                <ts-icon icon="ts_folder" class="mr-2"></ts-icon>
                Group
                <ng-container *ngIf="groupBy.length">
                  <ts-badge [value]="getGroupByLabel()" [type]="'success'"></ts-badge>
                </ng-container>
              </ts-button>
              <mat-form-field class="absolute top-9 invisible">
                <mat-select #groupSelect [(ngModel)]="groupBy" (selectionChange)="onChangeGroupBy($event)">
                  <mat-option value="">Select a field</mat-option>
                  <mat-option *ngFor="let fieldDef of taskFieldDefs" [value]="fieldDef.name">
                    {{ fieldDef.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <!-- Column Select Panel -->
              <app-column-selector
                *ngIf="taskFieldDefs"
                class="ml-4 mr-4"
                [matTooltip]="'Select columns'"
                [items]="taskFieldDefs"
                [selectedOrder]="selectedOrder"
                [draggable]="true"
                [showCountBadge]="true"
                [isButton]="true"
                (onSave)="onSaveColumns($event)"
              ></app-column-selector>

              <!-- List Filter Button -->
              <ts-button
                [debounceTime]="0"
                type="stroked"
                color="accent"
                [tsOverlayTriggerFor]="filtersOverlayBox"
                [matTooltip]="'Apply filters'"
                [appAuthorize]="NewPermission.AGGREGATED_TASK_LISTS_CREATE"
              >
                <ts-icon icon="ts_filter-list" class="mr-2"></ts-icon>
                Filter
                <ng-container *ngIf="filterCounter">
                  <ts-badge [value]="filterCounter" [type]="'info'"></ts-badge>
                </ng-container>
              </ts-button>
            </section>
          </ng-container>
        </ts-page-header>

        <!-- Loading Bar -->
        <ng-container *ngIf="isLoading">
          <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
        </ng-container>

        <!-- Aggregated Tasks Table -->
        <main class="tasks-list" [ngClass]="{ loading: isLoading }">
          <div class="table-wrapper">
            <div class="tasks-list-wrapper" *ngIf="selectedOrder">
              <div
                app-task-table
                [isAggregatedTask]="true"
                [condensedStatusView]="false"
                [tasks]="tasks"
                [data]="routeData"
                [users]="users"
                [taskFields]="routeData.taskFieldDefs"
                [taskStatuses]="workflowStates"
                [groupBy]="groupBy"
                (updateTask)="updateTask($event)"
                [selectedFields]="selectedFieldsTable"
                (navigateToTask)="openTaskDetails($event)"
                (navigateToTaskComment)="onNavigateToComments($event)"
                [canEdit]="canEdit"
              ></div>
            </div>
          </div>
        </main>

        <!-- Aggregated Tasks Footer -->
        <ts-paginator
          [ngClass]="{ loading: isLoading }"
          [totalItems]="pagination.length"
          [activePage]="pagination.page + 1"
          [pageSize]="pagination.size"
          (pageChanged)="onPageChange($event)"
        ></ts-paginator>
      </section>
    </mat-drawer-content>
  </mat-drawer-container>
</section>

<ng-template #noTasks>
  <div class="no-tasks py-12">
    <mat-icon [svgIcon]="'iconsmind:bulleted_list'"></mat-icon>
    <h4>Add a task to start planning!</h4>
  </div>
</ng-template>

<!-- List Filters Panel -->
<ts-overlay
  #filtersOverlayBox
  position="bottom"
  [transparentBackdrop]="true"
  (closeByBackdropClick)="onCloseByBackdropClick()"
>
  <ts-filter
    size="large"
    [fields]="typeFields | async"
    [filters]="filterValueList | async"
    [lookupContract]="lookupService"
    [hasGroups]="false"
    (addItem)="onAddFilterItem()"
    (filterDefChange)="onFilterDefChanged($event)"
    (filterRemove)="onFilterRemoved($event)"
    (filterClear)="onFilterCleared()"
    (filterApply)="onFilterApplied()"
  ></ts-filter>
</ts-overlay>
